import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClient } from '../core/api-client.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { PendingLettersComponent } from './pending-letters.component';
import { PendingLetterDetailsComponent } from './pending-letter-details.component';
import { EditLetterContentModalComponent } from './Modals/edit-letter-content-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';


@NgModule({
    declarations: [
        PendingLettersComponent,
        PendingLetterDetailsComponent,
        EditLetterContentModalComponent,
    ],
    imports: [
        CommonModule
        , BrowserModule
        , FormsModule
        , ReactiveFormsModule
        , NgbPaginationModule
        , RouterModule
        , EditorModule
    ],
    providers: [ApiClient],
})
export class PendingLettersModule { }
